@let isCreating =
  clustersEc.plugins.currentEntityPlugin.feature.selectors
    .isCreating()
    .asSignal();
@let hasDeletions =
  clustersEc.plugins.editingPlugin.feature.selectors.hasDeletions.asSignal();
@let isSubmitting =
  clustersEc.plugins.editingPlugin.feature.selectors.isSubmitting.asSignal();

<atn-ds-page>
  <atn-ds-table [config]="tableConfig" />
</atn-ds-page>

@if (isCreating) {
  <atn-space-cluster-modal />
}

@if (hasDeletions) {
  <atn-ds-confirmation-overlay
    title="Delete Cluster"
    description="Deleting this cluster will unassign all associated rooms. Are you sure you want to proceed?"
    confirmButtonText="Delete"
    (confirm)="confirmDeletionClickHandler()"
    (cancel)="cancelDeletionClickHandler()"
    [loading]="isSubmitting"
  />
}
